import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';

import type { ExperimentCohort, Product } from '../../../types';

export const useNBEAExperiment = ({
	fireExperimentExposure = false,
	product,
}: {
	fireExperimentExposure: boolean;
	product: Product;
}) => {
	const abExperimentKey = 'confluence_next_best_edition_recommend';
	let abCohort: ExperimentCohort = 'not-enrolled';

	if (product === 'confluence' && fg('edition_awareness_confluence_next_best_rec_fg')) {
		abCohort = FeatureGates.getExperimentValue<ExperimentCohort>(
			abExperimentKey,
			'cohort',
			'not-enrolled',
			{
				fireExperimentExposure,
			},
		);
	}

	return {
		abExperimentKey,
		abCohort,
	};
};
